<template>
  <div class="content-block-no-resize">
    <div class="content-wrapper">
      <slot></slot>
   </div>
  </div>
</template>

<script type="text/javascript">

export default ({
});


</script>

<style lang="less">

@import url('../../assets/v1/less/base.less');

.content-block-no-resize{
  .flex(column, flex-start, flex-start);
  position: relative;
  flex-grow: 1;

  width: 100%;

  overflow: hidden;


  .content-wrapper{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    overflow: auto;
  }
}


</style>
